import {computed, makeObservable, observable} from "mobx";
import ApiResponseHandler from "@eryxcoop/appyx-comm/src/errors/ApiResponseHandler";
import errorToast from "../../components/toast/ErrorToast";

export default class ListCustomersFeature {

    constructor(application, navigator) {
        this._application = application;
        this._navigate = navigator;
        this._loaded = false;
        this._customers = [];

        makeObservable(this, {
            _loaded: observable,
            loaded: computed,
            _customers: observable,
            customers: computed,
        })
    }

    async aValueChanged() {
        await this.reload();
    }


    async load() {
        await this._getCustomers()
        this.finishLoading()
    }

    async reload() {
        this._loaded = false;
        await this.load();
    }

    finishLoading() {
        this._loaded = true
    }

    get loaded() {
        return this._loaded;
    }

    set loaded(value) {
        this._loaded = value;
    }

    get customers() {
        return this._customers;
    }

    set customers(value) {
        this._customers = value;
    }

    columns() {
        return [
            {id: 'taxpayerIdentificationNumber', label: 'CUIT'},
            {id: 'fantasyName', label: 'Nombre de Fantasia'},
            {id: 'businessName', label: 'Nombre de Cliente'},
            {id: 'code', label: 'Codigo'},
        ];
    }

    presentedCustomers() {
        return this.customers.map(customer => {
            return this._presentCustomer(customer);
        });
    }

    _presentCustomer(customer) {
        return {
            id: customer.businessName,
            taxpayerIdentificationNumber:customer.taxpayerIdentificationNumber,
            fantasyName: customer.fantasyName,
            businessName: customer.businessName,
            code: customer.code,
        }
    }

    async _getCustomers() {
        const responseHandler = new ApiResponseHandler({
            handlesSuccess: (response) => {
                this.customers = response.customers();
            },
            handlesError: (response) => {
                errorToast('No se pudieron obtener los pedidos')
            }
        });
        return this._application.apiClient().getCustomers(responseHandler)
    }
}